export default class ConnectionAdapter {
  static connection() {
    return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  }

  static hasNetworkInformationObject() {
    return !!this.connection();
  }

  static liteModeEnabled() {
    if (!this.hasNetworkInformationObject()) return false;

    return this.connection().saveData;
  }

  static effectiveType() {
    if (!this.hasNetworkInformationObject()) return null;

    return this.connection().effectiveType;
  }

  static downlink() {
    if (!this.hasNetworkInformationObject()) return -1;

    return this.connection().downlink;
  }

  static type() {
    if (!this.hasNetworkInformationObject()) return undefined;

    return this.connection().type;
  }
}
